import {defineStore} from 'pinia'
import {useUserStore} from "@/stores/user";
import router from "@/router";

export const useWebsitesStore = defineStore('websites_store', {
    state: () => ({
        items: [],
        loading: false,
        loadedKdnr: null,
    }),
    getters: {
        getWebsiteById: (state) => {
            return (websiteId) => state.items.find((website) => website.id === websiteId)
        },
    },
    actions: {
        index(kdnr = null) {
            this.loading = true
            const resolvedKdnr = kdnr || useUserStore().user.organisation.kdnr || router.currentRoute.value.query.kdnr
            return this.apiClientV2.get('/websites', {params: {kdnr: resolvedKdnr}}).then(({data}) => {
                this.items = data.websites || []
                this.loadedKdnr = resolvedKdnr
                return {data}
            }).finally(() => {
                this.loading = false
            })
        },
    },
})
